// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer__Footer__3Gabt"};